import { formatBaht } from '@xver/utils/number';
import { IconCheck, IconGift } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@xver/components/Atoms';
import DialogBox from '@xver/components/Atoms/DialogBox/DialogBox';

import { useClaimTrialCreditMutation, useTrialCreditQuery } from '@xver/hooks/useTrialCredit';

export default function TrialCreditSection() {
    const { t } = useTranslation('profile');
    const statusQuery = useTrialCreditQuery();
    const claimMutation = useClaimTrialCreditMutation();

    const status = statusQuery.data;

    if (!status?.available) {
        return null;
    }

    const amountText = formatBaht(status.amount);

    return (
        <DialogBox label={t('trial.title')} description={t('trial.description')} classNames="p-4">
            {status.claimed ? (
                <div className="w-full flex flex-row items-center gap-3">
                    <IconCheck size={28} className="text-green-400 light:text-green-800" />
                    <div className="flex flex-col">
                        <span className="text-base font-semibold">{t('trial.claimedTitle')}</span>
                        <span className="text-sm text-fg/68">{t('trial.claimedDescription')}</span>
                    </div>
                </div>
            ) : (
                <div className="w-full flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                    <div className="flex flex-row items-center gap-3">
                        <IconGift size={28} className="text-fg/80" />
                        <div className="flex flex-col">
                            <span className="text-base font-semibold">
                                {t('trial.offer', { amount: amountText })}
                            </span>
                            <span className="text-sm text-fg/68">
                                {status.kycPassed
                                    ? [
                                          status.validityDays
                                              ? t('trial.validity', {
                                                    days: status.validityDays,
                                                })
                                              : t('trial.noExpiry'),
                                          status.products && status.products.length > 0
                                              ? t('trial.products', {
                                                    products: status.products.join(', '),
                                                })
                                              : t('trial.allProducts'),
                                      ].join(' · ')
                                    : t('trial.kycRequired')}
                            </span>
                        </div>
                    </div>
                    <Button
                        onClick={() => claimMutation.mutate()}
                        disabled={!status.kycPassed}
                        isLoading={claimMutation.isPending}
                    >
                        {t('trial.claim', { amount: amountText })}
                    </Button>
                </div>
            )}
        </DialogBox>
    );
}
